
import { useEffect, useState } from 'react';
import Card from '../../../components/base/Card';

export default function ServicesSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const element = document.getElementById('services-section');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: 'ri-bank-card-fill',
      title: 'Reestructuración de crédito profesional',
      description: 'Mejora tu score crediticio con estrategias probadas y acompañamiento personalizado.'
    },
    {
      icon: 'ri-building-fill',
      title: 'Creación de LLCs y corporaciones',
      description: 'Estructura legal sólida para proteger y hacer crecer tu patrimonio empresarial.'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Funding empresarial y expansión',
      description: 'Accede a capital para expandir tu negocio con las mejores condiciones del mercado.'
    },
    {
      icon: 'ri-graduation-cap-fill',
      title: 'Mentorías y comunidad educativa',
      description: 'Aprende de expertos y conecta con una comunidad exclusiva en Skool.'
    }
  ];

  return (
    <section id="services-section" className="py-12 sm:py-16 lg:py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6">
        <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 sm:mb-6">
            Nuestros <span className="text-yellow-400">Servicios</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto px-4">
            Soluciones integrales para llevar tu negocio al siguiente nivel
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              variant="service"
              className={`p-6 sm:p-8 text-center transition-all duration-1000 delay-${index * 100} ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className={`${service.icon} text-black text-2xl sm:text-3xl`}></i>
              </div>
              
              <h3 className="text-lg sm:text-xl font-bold text-yellow-400 mb-3 sm:mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
                {service.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
